const __request = require('./__request/__request_contentType_json');
const request = (data) => {
    let pParameter = {
        method: 'post',
        urlSuffix: '/flight/order/report/list',
        data: data
    }
    return __request(pParameter)
}
export default request